import React, { useEffect, useState } from 'react';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import SingleLineCharts from '../../ui/SinglelineCharts/singlelineCharts';
import SingleTabTable from '../../ui/SingleTabTable';
import styles from '../maiWidgets/mai-widget.module.css';

export default function Day0Widget() {
  const {  state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.d0Data;
  const loader = state.dashboardData.isLoading.d0Data;
  const { filters } = state;
  const [isOn, setIsOn] = useState(false);

  const [currentTDPData, setCurrentTDPData] = useState([]);

  const getDataKey = (item) => {
    if (item.day) return item.day;
    if (item.tdp) return item.tdp;
    return 'Unknown';
  };

  const transformedChartData = Array.isArray(chartData)
    ? chartData.map((item, index) => ({
        label: getDataKey(item),
        value: item.value,
        isCurrent:
          item.tdp ? false : !filters.actionFilter?.length && index === chartData.length - 1,
        ...item,
      }))
    : [];

  useEffect(() => {
    if (!chartData || !Array.isArray(chartData)) {
      setCurrentTDPData([]);
      return;
    }

    const match = chartData.find(
      (data) =>
        data.label === filters.tdp || data.TDP === filters.tdp
    );

    const matchedData = filters.actionFilter
      ? chartData.find((data) => data.label === filters.tdp || data.label?.includes("TDP"))?.data || []
      : match && Array.isArray(match.data)
      ? match.data
      : transformedChartData;

    setCurrentTDPData(matchedData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.tdp, chartData, filters.actionFilter]);

  return (
    <WidgetWrapper
      title="Day 0"
      isTableView={globalViewMode === 'table'}
      isDialogOpen={isOn}
      setIsDialogOpen={()=>setIsOn(!isOn)}
      infoText="Day 0 measures fulfilling customer orders on the same day they are received. (GT, KA, RD)"
    >
      {loader ? (
        <div style={{ width: '100%', height: '100%' }}>
          <ChartSkeleton isOn={false} />
        </div>
      ) : (
        <div style={{ height: '100%' }}>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts
              data={isOn ? currentTDPData : currentTDPData.slice(0,4)}
              dataKey="label"
              valueKey="value"
              isExpansionNeeded={!!filters.actionFilter}
            />
          ) : (
            <SingleTabTable
              data={
                filters.actionFilter
                  ? isOn ? chartData?.[chartData.length - 1]?.data || [] : chartData?.[chartData.length - 1]?.data?.slice(0,4) || []
                  : isOn ? currentTDPData : currentTDPData.slice(0,4)
              }
              keys={['label', 'value']}
              colorLogic={(value) => {
                if (value >= 60) return styles.textGreen;
                if (value >= 50) return styles.textYellow;
                if (value >= 30) return styles.textPink;
                return styles.textRed;
              }}
              customRowClass={(row) => {
                return row.type === 'tdp' ? styles.tdp : '';
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
